import { UserContext } from '@zola-helpers/client/dist/es/@types';
import experimentFlagsHelper from '@zola-helpers/client/dist/es/util/experimentFlagsHelper';

// Experiment Keys:
// 👇 example key (currently deprecated)
// export const EXAMPLE_FLAG = 'example-flag;
// keep for cookie value?
export const AUTH_FORM_V2 = 'auth-form-v2'; // INSPO-4327
export const MARKETPLACE_MEGA_MENU_AB_TEST = 'marketplace-mega-menu-ab-test'; // https://newamsterdamlabs.atlassian.net/browse/INSPO-7013 - roll out 50% of pre-auth users
export const RECAPTCHA_REFACTOR = 'recaptcha-refactor'; // https://newamsterdamlabs.atlassian.net/browse/CE-2186
export const SHOP_HOLIDAYS_2022 = 'holidaysShop2022'; // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-2416
export const HOLIDAYS_2022 = 'holidays2022';
export const PAPER_SECONDARY_NAV_REDESIGN = 'paper-secondary-nav-redesign-v3'; // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-2463
export const CORE_MWEB_POST_AUTH_NAV_V3 = 'core-mweb-post-auth-nav-v3'; // https://newamsterdamlabs.atlassian.net/browse/CE-3399
export const PAPER_TABLE_NUMBER = 'paper-table-number';
export const NAV_PAPER_BOUTIQUE = 'nav-paper-boutique';
export const MANAGE_REGISTRY_PAGE_V2 = 'manage-registry-page-v2'; // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-3207
export const UNIVERSAL_SEARCH = 'universal-search-suggestions'; // https://newamsterdamlabs.atlassian.net/browse/CE-3459

const FALLBACK_VARIATIONS = {
  // 👇 example variation (currently deprecated)
  // [EXAMPLE_FLAG]: experimentFlagsHelper.createExperimentFlags(),
  [AUTH_FORM_V2]: experimentFlagsHelper.createExperimentFlags(),
  [SHOP_HOLIDAYS_2022]: experimentFlagsHelper.createExperimentFlags(),
  [MARKETPLACE_MEGA_MENU_AB_TEST]: experimentFlagsHelper.createExperimentFlags(),
  [RECAPTCHA_REFACTOR]: experimentFlagsHelper.createExperimentFlags(),
  [HOLIDAYS_2022]: experimentFlagsHelper.createExperimentFlags(),
  [PAPER_SECONDARY_NAV_REDESIGN]: experimentFlagsHelper.createExperimentFlags(),
  [CORE_MWEB_POST_AUTH_NAV_V3]: experimentFlagsHelper.createExperimentFlags(),
  [PAPER_TABLE_NUMBER]: experimentFlagsHelper.createExperimentFlags(),
  [NAV_PAPER_BOUTIQUE]: experimentFlagsHelper.createExperimentFlags(),
  [MANAGE_REGISTRY_PAGE_V2]: experimentFlagsHelper.createExperimentFlags(),
  [UNIVERSAL_SEARCH]: experimentFlagsHelper.createExperimentFlags(),
};

const {
  getFlag,
  getExperimentVariation,
  isUnderTest,
  isInExperiment,
} = experimentFlagsHelper.makeExperimentFlags(FALLBACK_VARIATIONS);

export const isInMarketplaceMegaMenuTest = (userContext?: UserContext | null): boolean =>
  isUnderTest(MARKETPLACE_MEGA_MENU_AB_TEST, userContext);

export default {
  getExperimentVariation,
  isUnderTest,
  getFlag,
  isInExperiment,
};
